import types from './types';
import create from '~/misc/create';
import store from "~/store";


export const setSelectPlan = (dispatch,payload) => store.dispatch(create(types.SELECTED_PAYMENT_PLAN, payload));

export const saveOrderInfoAction = (payload) => store.dispatch(create(types.SAVE_ORDER_INFO, payload));
export const savePayInfoAction = (payload) => store.dispatch(create(types.SAVE_PAY_INFO, payload));
export const saveOrderStatusAction = (payload) => store.dispatch(create(types.SAVE_ORDER_STATUS, payload))
export const setOrderLoadingStatusAction = (payload) => store.dispatch(create(types.SET_ORDER_LOADING_STATUS, payload))



// WEBPACK FOOTER //
// ./src/modules/payment/actions.js